import * as HomeActions from "./home.actions";
import * as AuthActions from "./auth.actions";
import * as Login from "./currentuser/login.actions";
import * as AdministrationUsers from "./administration/users.actions";
import * as AdministrationUserGroupMemberships from "./administration/userGroupMemberships.actions";
import * as AdministrationZones from "./administration/zones.actions";
import * as AdministrationCategories from "./administration/categories.actions";
import * as AdministrationUserGroups from "./administration/userGroups.actions";
import * as AdministrationContentGroups from "./administration/contentGroups.actions";
import * as AdministrationInvitations from "./administration/invitations.actions";
import * as AdministrationPermissions from "./administration/permissions.actions";
import * as Contents from "./contents/contents.actions";
import * as Carousel from "./contents/carousel.actions";
import * as Compositions from "./contents/compositions.actions";
import * as VideoMessages from "./contents/videomessages.actions";
import * as Playlists from "./contents/playlists.actions";
import * as Schedules from "./contents/schedules.actions";
import * as MonitoringDisplayGroups from "./monitoring/displayGroups.actions";
import * as MonitoringDisplays from "./monitoring/displays.actions";
import * as MonitoringCommands from "./monitoring/commandsToPlayer.actions";
import * as Reporting from "./monitoring/reporting.actions";
import * as Deployments from "./deployments/deployments.actions";
import * as Alert from "./alertDialog.actions";
import * as Configuration from "./configuration.actions";
import * as Widgets from "./widgets.actions";
import * as Styles from "./styles.actions";
import * as Tags from "./tags.actions";
import * as SuperAdmin from "./superAdmin.actions";
import * as ImageOrientation from "./ImageOrientation.actions";
import * as Forms from "./datasources/forms.actions";

export const ActionsCreators = Object.assign({},
    HomeActions,
    AuthActions.actionCreators,
    Configuration.actionCreators,

    Login.actionCreators,

    AdministrationUsers.actionCreators,
    AdministrationUserGroupMemberships.actionCreators,
    AdministrationZones.actionCreators,
    AdministrationCategories.actionCreators,
    AdministrationUserGroups.actionCreators,
    AdministrationContentGroups.actionCreators,
    AdministrationInvitations.actionCreators,
    AdministrationPermissions.actionCreators,

    Contents.actionCreators,
    Carousel.actionCreators,
    Compositions.actionCreators,
    VideoMessages.actionCreators,
    Playlists.actionCreators,
    Schedules.actionCreators,


    MonitoringDisplayGroups.actionCreators,
    MonitoringDisplays.actionCreators,
    MonitoringCommands.actionCreators,
    Reporting.actionCreators,

    Deployments.actionCreators,

    Alert.actionCreators,

    Widgets.actionCreators,

    Styles.actionCreators,
    Tags.actionCreators,

    SuperAdmin.actionCreators,

    ImageOrientation.actionCreators,

    Forms.actionCreators,
);
